export default __webpack_public_path__ + "static/media/W_Aplus_False.e618047d.jpg";